import React, { FC } from "react";

import { StatusColorType, StyledStatus } from "./styled";

export interface StatusProps extends React.HTMLAttributes<HTMLDivElement> {
    color?: StatusColorType;
    text?: string;
    noBullet?: boolean;
}

const Status: FC<StatusProps> = ({ color, text, noBullet = false, ...props }) => {
    if (!color || !text) return <></>;

    return (
        <StyledStatus $color={color} $noBullet={noBullet} {...props}>
            {text}
        </StyledStatus>
    );
};

export default Status;
